<template>
  <div class="sub_alfx_detail">
    <header class="n-fixed-top bg-c bColor">
      <div class="left" v-if="$route.name !== 'index'" @click="back()">
        <div class="n-back"></div>
      </div>
      <h4>
        <span>{{ titleValue }}</span>
      </h4>
      <div class="right" v-if="$route.name !== 'index'"></div>
    </header>

    <!-- <video :src="fileUrl" controls="controls" x-webkit-airplay="true" webkit-playsinline="true" playsinline="true" v-if="file_type=='video'"></video> -->
    <!--<iframe v-bind:src="fileiframe" frameborder="0" allowtransparency="true" class="k-iframe" v-bind:style="" v-else></iframe>-->
    <div v-if="ispdf">
      <iframe
        :src="urlParams.url"
        frameborder="0"
        allowtransparency="true"
        class="pdf k-iframe"
        id="iframe"
      ></iframe>
    </div>
    <div v-else class="pdf">
      <MyAlipdf :url="{ url: fileUrl }" :urlParams="urlParams"></MyAlipdf>
    </div>
  </div>
</template>
<script>
import MyAlipdf from "components/MyAlipdf/index.vue";
import { static_pdf_URL } from "../../api/global_variable";
export default {
  components: {
    MyAlipdf,
  },
  data() {
    return {
      titleValue: this.$t("sub_index.preview"),
      fileUrl: "",
      // fileiframe:"",
      ispdf: true, // 默认使用pdfjs
      urlParams: {
        url: "https://img.dev.eceibs.net/document/intest/vector/8809801e50694b848dba7a5d3dd0e78d",
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.file_type=this.$route.query.file_type;
      this.fileUrl = this.$route.query.fileUrl;

      // if(this.file_type=='video'){
      //     this.titleValue='视频预览'
      // }
      //            this.fileUrl=g_baseURL+'/index.php/mobile/file/media?user_id='+localStorage.getItem('_user_data_id')+'&company_id='+localStorage.getItem('_user_data_company_id')+'&sso_token='+localStorage.getItem('_user_data_sso_token')+'&sys_id=5&language='+localStorage.getItem('_user_data_language')+'&hash='+this.hash;
      // this.fileiframe=g_baseURL+'/index.php/h5/index?path=pdf_show2&user_id='+localStorage.getItem('_user_data_id')+'&company_id='+localStorage.getItem('_user_data_company_id')+'&sso_token='+localStorage.getItem('_user_data_sso_token')+'&sys_id=5&language='+localStorage.getItem('_user_data_language')+'&hash='+this.hash+'&dm='+g_baseURL+'/';
      //            this.fileUrl= 'http://file.dev.eceibs.net/document/intest/pdf/4009a7623903476fbcc1ec3195b45b08.pdf?auth_key=1560393196-30211231DA6E64AB5B849CC456576675-0-d96d89b2c195a873d6ca3c795cf93099'
      if (this.fileUrl.indexOf("pdf?auth_key") == -1) {
        // 阿里向量模式
        this.ispdf = false;
        this.urlParams = {
          url: this.fileUrl
            ? this.fileUrl
            : "https://img.dev.eceibs.net/document/intest/vector/8809801e50694b848dba7a5d3dd0e78d",
        };
      } else {
        // pdf的文件
        this.ispdf = true;
        this.urlParams.url = `${static_pdf_URL}/pdf/web/viewer.html?file=${encodeURIComponent(
          this.fileUrl
        )}`;
        //              this.urlParams.url = this.fileUrl;
      }
    });
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_alfx_detail {
  .k-iframe {
    margin-top: 0.2rem;
    width: 100%;
    min-height: calc(100vh - 0.92rem);
  }
}
</style>
